<template>
  <div>
    <app-sidebar />
    <div class="rightpart">
      <div class="rightpart_in">
        <div class="tokyo_tm_section">
          <div class="container">
            <div class="tabcontent">
              <div class="tokyo_tm_home">
                <div class="home_content">
                  <div class="avatar">
                    <div class="image avatar_img">
                      <img src="../assets/2.jpg" alt="" />
                    </div>
                  </div>
                  <div class="details">
                    <h3 class="name">Demola Alaofin</h3>
                    <h4 class="stack">
                      <vue-typer
                        :text="[
                          'Web Designer',
                          'Web Developer',
                          'Javascript Lover',
                          'Laravel Lover',
                        ]"
                        :repeat="Infinity"
                        :shuffle="true"
                        initial-action="typing"
                        :pre-type-delay="70"
                        :type-delay="70"
                        :pre-erase-delay="2000"
                        :erase-delay="250"
                        erase-style="backspace"
                        :erase-on-complete="false"
                        caret-animation="blink"
                      ></vue-typer>
                    </h4>
                    <p class="job">
                      I'm Creative Web Developer, and I'm very passionate and
                      dedicated to my work. With 5 years experience as a
                      professional web developer, I have acquired the skills and
                      knowledge necessary to make project a success.
                    </p>
                    <ul class="social">
                      <li>
                        <a
                          href="https://www.linkedin.com/in/demola-alaofin-02a01a1a3/"
                          target="_blank"
                          rel="noreferrer"
                          ><i class="fa fa-linkedin-square"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          href="https://www.github.com/wapmastaz"
                          target="_blank"
                          rel="noreferrer"
                          ><i class="fa fa-github"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          href="https://twitter.com/DemolaTheo"
                          target="_blank"
                          rel="noreferrer"
                          ><i class="fa fa-twitter-square"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          href=" https://wa.me/2349035355945"
                          target="_blank"
                          rel="noreferrer"
                          ><i class="fa fa-whatsapp"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidebar from './shared/sidebar.vue';
import { VueTyper } from 'vue-typer';
export default {
  name: 'Home',
  components: {
    'app-sidebar': sidebar,
    'vue-typer': VueTyper,
  },
};
</script>

<style>
@keyframes rocking {
  0%,
  100% {
    transform: rotateZ(-10deg);
  }
  ,
  50% {
    transform: rotateZ(10deg);
  }
}

.vue-typer {
  font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
}
.vue-typer .custom.char.typed {
  color: #009688;
}
.vue-typer .custom.char.selected {
  color: #e91e63;
}

.vue-typer .custom.caret {
  animation: rocking 1s ease-in-out 0s infinite;
}
.vue-typer .custom.caret.typing {
  background-color: #009688;
}
.vue-typer .custom.caret.selecting {
  display: inline-block;
  background-color: #e91e63;
}
</style>
